export default __webpack_public_path__ + "images/ff7346beef4a66829054380bc693d812-agnostic.webp";